import React from 'react';
import { BsWhatsapp, BsGithub } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
        <a href="https://wa.me/+923115914586" target="_blank">
      <BsWhatsapp />
      </a>
    </div>
    <div>
    <a href="https://www.facebook.com/profile.php?id=100008751400618" target="_blank">
      <FaFacebookF />
      </a>
    </div>
    <div>
        <a href="https://github.com/ArbazKhanGul" target="_blank">
      <BsGithub />
      </a>
    </div>
  </div>
);

export default SocialMedia;